import type { Mark } from "./types.js";

/**
 * Solent racing marks — imported from the GoAstern passage-planning
 * app (Solentmarks2026.gpx). 139 marks covering Poole Bay through
 * Spithead, used by RTYC, JOG, RORC, and weekly Cowes racing.
 *
 * Each mark is treated as a yellow special-purpose buoy (IALA-A
 * "special mark") with the standard Fl.Y.4s character. In real life
 * many of these are sponsored buoys ("Hill Robinson", "Draycott
 * Chartered Surveyors", etc.) deployed for race-season only. Real
 * radar paint depends on the buoy size; we use a small 0.05 RCS for
 * all of them so they read as light returns relative to the
 * authoritative navigation marks.
 */
export const RACING_MARKS: ReadonlyArray<Mark> = [
// 139 racing marks imported from Solentmarks2026.gpx
  {
    id: "rm-1a-peveril-ledge",
    name: "1A Peveril Ledge",
    position: { lat: 50.606833, lon: -1.935 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-1b-poole-bar-no-1",
    name: "1B Poole Bar No 1",
    position: { lat: 50.654833, lon: -1.919 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-1c-stoneways-marine",
    name: "1C Stoneways Marine",
    position: { lat: 50.671833, lon: -1.900333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-1d-the-rig-shop",
    name: "1D The Rig Shop",
    position: { lat: 50.684667, lon: -1.904333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-1e-ledge-buoy",
    name: "1E Ledge Buoy",
    position: { lat: 50.691667, lon: -1.693333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-1f-needles-fairway",
    name: "1F Needles Fairway",
    position: { lat: 50.637333, lon: -1.649667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-1h-bridge",
    name: "1H Bridge",
    position: { lat: 50.6605, lon: -1.614667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-1j-shingles-elbow",
    name: "1J Shingles Elbow",
    position: { lat: 50.672833, lon: -1.600833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-1k-north-head",
    name: "1K North Head",
    position: { lat: 50.7115, lon: -1.592 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-1m-warden",
    name: "1M Warden",
    position: { lat: 50.691333, lon: -1.559167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-1n-north-east-shingles",
    name: "1N North East Shingles",
    position: { lat: 50.699333, lon: -1.556833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-11-east-hook",
    name: "11 East Hook",
    position: { lat: 50.676333, lon: -1.9205 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-12-mid-bay-buoy",
    name: "12 Mid Bay Buoy",
    position: { lat: 50.71, lon: -1.68 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-13-parkstone-yc",
    name: "13 Parkstone YC",
    position: { lat: 50.660167, lon: -1.92 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2a-hill-robinson",
    name: "2A Hill Robinson",
    position: { lat: 50.712833, lon: -1.5405 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2b-dunford-construction",
    name: "2B Dunford Construction",
    position: { lat: 50.723, lon: -1.525667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2c-colten",
    name: "2C Colten",
    position: { lat: 50.7305, lon: -1.514333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2d-lymington-yacht-haven",
    name: "2D Lymington Yacht Haven",
    position: { lat: 50.737333, lon: -1.498333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2e-circle-marine-insurance",
    name: "2E Circle Marine Insurance",
    position: { lat: 50.7415, lon: -1.488667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2f-berthon",
    name: "2F Berthon",
    position: { lat: 50.736667, lon: -1.487 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2g-bridgeworks-wan-acceleration",
    name: "2G Bridgeworks WAN Acceleration",
    position: { lat: 50.7465, lon: -1.4745 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2h-draycott-chartered-surveyors",
    name: "2H Draycott Chartered Surveyors",
    position: { lat: 50.738333, lon: -1.469333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2j-zwerver",
    name: "2J Zwerver",
    position: { lat: 50.751833, lon: -1.455667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2k-greenings-fintech",
    name: "2K Greenings Fintech",
    position: { lat: 50.747167, lon: -1.434833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2l-royal-lymington-yc",
    name: "2L Royal Lymington YC",
    position: { lat: 50.719, lon: -1.5325 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2r-powder-byrne",
    name: "2R Powder Byrne",
    position: { lat: 50.757167, lon: -1.4315 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2t-lymington-bank",
    name: "2T Lymington Bank",
    position: { lat: 50.718333, lon: -1.514167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-2u-tuakana-construction",
    name: "2U Tuakana Construction",
    position: { lat: 50.727833, lon: -1.491667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-20-sconce",
    name: "20 Sconce",
    position: { lat: 50.708833, lon: -1.523833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-21-black-rock",
    name: "21 Black Rock",
    position: { lat: 50.7095, lon: -1.509833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-22-raymond-james-charles-stanley",
    name: "22 Raymond James Charles Stanley",
    position: { lat: 50.714333, lon: -1.49 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-24-bdm-cx",
    name: "24 BDM CX",
    position: { lat: 50.714333, lon: -1.473667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-25-contessa-26-association",
    name: "25 Contessa 26 Association",
    position: { lat: 50.719167, lon: -1.458167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-26-hamstead-ledge",
    name: "26 Hamstead Ledge",
    position: { lat: 50.731167, lon: -1.436333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-27-adam-harding-domeney",
    name: "27 Adam Harding-Domeney",
    position: { lat: 50.716167, lon: -1.469333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-28-harwoods",
    name: "28 Harwoods",
    position: { lat: 50.712167, lon: -1.478167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3a-west-lepe",
    name: "3A West Lepe",
    position: { lat: 50.754, lon: -1.4015 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3b-newtown-east",
    name: "3B Newtown East",
    position: { lat: 50.739333, lon: -1.396667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3c-basher",
    name: "3C Basher",
    position: { lat: 50.760667, lon: -1.385333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3d-salt-mead",
    name: "3D Salt Mead",
    position: { lat: 50.741833, lon: -1.384 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3e-the-boss",
    name: "3E The Boss",
    position: { lat: 50.768833, lon: -1.369833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3f-markby",
    name: "3F Markby",
    position: { lat: 50.745333, lon: -1.365833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3g-cowes-week-200",
    name: "3G Cowes Week 200",
    position: { lat: 50.776333, lon: -1.357667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3h-east-lepe",
    name: "3H East Lepe",
    position: { lat: 50.7655, lon: -1.351167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3l-gurnard-ledge",
    name: "3L Gurnard Ledge",
    position: { lat: 50.7585, lon: -1.343167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3n-mdl-marinas",
    name: "3N MDL Marinas",
    position: { lat: 50.7845, lon: -1.331333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3p-cowes-yacht-haven",
    name: "3P Cowes Yacht Haven",
    position: { lat: 50.761333, lon: -1.333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3q-polly-apos-s-challenge",
    name: "3Q Polly&apos;s Challenge",
    position: { lat: 50.766167, lon: -1.324167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3r-north-east-gurnard",
    name: "3R North East Gurnard #",
    position: { lat: 50.784333, lon: -1.323667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3s-scra-org-uk",
    name: "3S SCRA.ORG.UK",
    position: { lat: 50.796833, lon: -1.320833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3t-chs",
    name: "3T CHS",
    position: { lat: 50.768333, lon: -1.3145 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3u-gurnard",
    name: "3U Gurnard",
    position: { lat: 50.770333, lon: -1.314 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3w-williams-shipping",
    name: "3W Williams Shipping",
    position: { lat: 50.786667, lon: -1.309167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3x-island-sailing-club",
    name: "3X Island Sailing Club",
    position: { lat: 50.768333, lon: -1.307167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3y-west-knoll",
    name: "3Y West Knoll",
    position: { lat: 50.7905, lon: -1.297333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-3z-trinity-house-buoy",
    name: "3Z Trinity House Buoy",
    position: { lat: 50.771833, lon: -1.295833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-30-rorc",
    name: "30 RORC",
    position: { lat: 50.785333, lon: -1.295333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-31-south-bramble",
    name: "31 South Bramble",
    position: { lat: 50.783, lon: -1.295333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-34-cowes-corinthian",
    name: "34 Cowes Corinthian",
    position: { lat: 50.769167, lon: -1.286667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-39-snowden",
    name: "39 Snowden",
    position: { lat: 50.77, lon: -1.295833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4a-reach",
    name: "4A Reach #",
    position: { lat: 50.8175, lon: -1.294167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4b-coronation",
    name: "4B Coronation",
    position: { lat: 50.825833, lon: -1.293667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4c-fumesy",
    name: "4C Fumesy",
    position: { lat: 50.820167, lon: -1.291 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4e-andy-cassell",
    name: "4E Andy Cassell",
    position: { lat: 50.7945, lon: -1.283333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4f-royal-thames",
    name: "4F Royal Thames",
    position: { lat: 50.786667, lon: -1.283333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4g-chieftain-training",
    name: "4G Chieftain Training",
    position: { lat: 50.824167, lon: -1.281833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4h-east-knoll",
    name: "4H East Knoll",
    position: { lat: 50.799333, lon: -1.2805 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4j-hamblewinterseries-com",
    name: "4J hamblewinterseries.com",
    position: { lat: 50.8105, lon: -1.276 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4k-royal-london",
    name: "4K Royal London",
    position: { lat: 50.769167, lon: -1.2775 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4l-jane",
    name: "4L Jane",
    position: { lat: 50.817167, lon: -1.274833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4m-hill-head",
    name: "4M Hill Head",
    position: { lat: 50.801167, lon: -1.266667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4n-ben-f-wood",
    name: "4N Ben F Wood",
    position: { lat: 50.787833, lon: -1.265 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4q-john-fisher",
    name: "4Q John Fisher",
    position: { lat: 50.807667, lon: -1.262 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4r-darling-buoy",
    name: "4R Darling Buoy",
    position: { lat: 50.819667, lon: -1.261833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4s-royal-southern",
    name: "4S Royal Southern",
    position: { lat: 50.814333, lon: -1.257167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4t-norris",
    name: "4T Norris #",
    position: { lat: 50.766167, lon: -1.2585 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4u-goodall-roofing",
    name: "4U Goodall Roofing",
    position: { lat: 50.773833, lon: -1.2515 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4v-hamble-yacht-services",
    name: "4V Hamble Yacht Services",
    position: { lat: 50.802167, lon: -1.244 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4w-ancasta",
    name: "4W Ancasta",
    position: { lat: 50.788833, lon: -1.243167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-4x-colette",
    name: "4X Colette",
    position: { lat: 50.758833, lon: -1.239833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-40-haven-knox-johnston-specialist",
    name: "40 Haven Knox Johnston Specialist",
    position: { lat: 50.794333, lon: -1.2275 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-42-peel-bank",
    name: "42 Peel Bank",
    position: { lat: 50.758167, lon: -1.2225 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-43-little-ship-club",
    name: "43 Little Ship Club",
    position: { lat: 50.769333, lon: -1.218167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-44-royal-yacht-squadron",
    name: "44 Royal Yacht Squadron",
    position: { lat: 50.7885, lon: -1.201667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-47-contessa-32-class",
    name: "47 Contessa 32 Class",
    position: { lat: 50.795, lon: -1.254167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-48-paul-heys",
    name: "48 Paul Heys",
    position: { lat: 50.8035, lon: -1.278 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-49-250th-anniversary",
    name: "49 250th Anniversary",
    position: { lat: 50.773333, lon: -1.226333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-5a-quarr",
    name: "5A Quarr",
    position: { lat: 50.7505, lon: -1.198167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-5d-kemps-quay",
    name: "5D Kemps Quay",
    position: { lat: 50.753, lon: -1.160833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-5e-stokes-bay-east",
    name: "5E Stokes Bay East",
    position: { lat: 50.771, lon: -1.146 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-5f-north-sturbridge",
    name: "5F North Sturbridge",
    position: { lat: 50.7555, lon: -1.137167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-5g-baker-trayte-marine",
    name: "5G Baker Trayte Marine",
    position: { lat: 50.773667, lon: -1.131667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-5h-portsmouth-sc",
    name: "5H Portsmouth SC",
    position: { lat: 50.780333, lon: -1.1225 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-5j-kb-dry-stack",
    name: "5J KB Dry Stack",
    position: { lat: 50.776833, lon: -1.1215 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-5k-naomi-house-amp-jacksplace",
    name: "5K Naomi House &amp; Jacksplace",
    position: { lat: 50.784667, lon: -1.113 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-5m-gleeds",
    name: "5M Gleeds",
    position: { lat: 50.7685, lon: -1.108667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-5p-www-victoryclass-org-uk",
    name: "5P www.victoryclass.org.uk",
    position: { lat: 50.772667, lon: -1.101333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-5q-outer-spit",
    name: "5Q Outer Spit *",
    position: { lat: 50.757333, lon: -1.091 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-50-fairhall-west",
    name: "50 Fairhall West @",
    position: { lat: 50.780167, lon: -1.173333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-51-sbsc-central",
    name: "51 SBSC Central @",
    position: { lat: 50.776667, lon: -1.164167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6a-no-man-apos-s-land-fort",
    name: "6A No Man&apos;s Land Fort",
    position: { lat: 50.74, lon: -1.095 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6c-warner",
    name: "6C Warner",
    position: { lat: 50.731167, lon: -1.0665 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6d-horse-elbow",
    name: "6D Horse Elbow",
    position: { lat: 50.737667, lon: -1.064667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6e-west-princessa",
    name: "6E West Princessa",
    position: { lat: 50.669333, lon: -1.060833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6g-st-helens-buoy",
    name: "6G St Helens Buoy",
    position: { lat: 50.722667, lon: -1.040167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6h-dean-elbow",
    name: "6H Dean Elbow",
    position: { lat: 50.728167, lon: -1.031333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6j-nab-east",
    name: "6J Nab East",
    position: { lat: 50.714333, lon: -1.013333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6k-horse-tail",
    name: "6K Horse Tail",
    position: { lat: 50.7205, lon: -1.003833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6l-winner",
    name: "6L Winner",
    position: { lat: 50.751667, lon: -1.001667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6m-nab-end",
    name: "6M Nab End",
    position: { lat: 50.7105, lon: -0.9915 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6n-dean-tail",
    name: "6N Dean Tail",
    position: { lat: 50.7165, lon: -0.986167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6p-new-grounds",
    name: "6P New Grounds",
    position: { lat: 50.697333, lon: -0.974833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-6s-outer-nab-no-2",
    name: "6S Outer Nab No 2",
    position: { lat: 50.6405, lon: -0.961667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7a-gymp",
    name: "7A Gymp",
    position: { lat: 50.8845, lon: -1.402667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7b-hythe-knock",
    name: "7B Hythe Knock",
    position: { lat: 50.8805, lon: -1.396833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7c-no-1-swinging",
    name: "7C No 1 Swinging",
    position: { lat: 50.883333, lon: -1.390667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7d-weston-shelf",
    name: "7D Weston Shelf",
    position: { lat: 50.8785, lon: -1.387667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7h-moorhead",
    name: "7H Moorhead",
    position: { lat: 50.875833, lon: -1.381667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7j-deans-elbow",
    name: "7J Deans Elbow",
    position: { lat: 50.87, lon: -1.380833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7k-nw-netley",
    name: "7K NW Netley",
    position: { lat: 50.871833, lon: -1.378833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7l-hovercraft-4",
    name: "7L Hovercraft 4",
    position: { lat: 50.877667, lon: -1.373667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7n-swsa-hsc",
    name: "7N SWSA/HSC",
    position: { lat: 50.862667, lon: -1.371333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7p-hovercraft-3",
    name: "7P Hovercraft 3",
    position: { lat: 50.873833, lon: -1.366833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7q-netley",
    name: "7Q Netley",
    position: { lat: 50.867167, lon: -1.3635 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7r-lains-lake",
    name: "7R Lains Lake",
    position: { lat: 50.859833, lon: -1.360833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7s-deans-lake",
    name: "7S Deans Lake",
    position: { lat: 50.856667, lon: -1.359833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7t-hovercraft-2",
    name: "7T Hovercraft 2",
    position: { lat: 50.870167, lon: -1.359667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7u-hound",
    name: "7U Hound",
    position: { lat: 50.861333, lon: -1.358667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7v-hovercraft-1",
    name: "7V Hovercraft 1",
    position: { lat: 50.8665, lon: -1.352667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7w-after-barn",
    name: "7W After Barn",
    position: { lat: 50.858833, lon: -1.347 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7y-cadland",
    name: "7Y Cadland",
    position: { lat: 50.850333, lon: -1.342333 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-7z-greenland",
    name: "7Z Greenland",
    position: { lat: 50.851833, lon: -1.339667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-70-warsash-sailing-club",
    name: "70 Warsash Sailing Club",
    position: { lat: 50.8435, lon: -1.320667 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-72-hamble-point",
    name: "72 Hamble Point",
    position: { lat: 50.835833, lon: -1.311 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-73-bald-head",
    name: "73 Bald Head",
    position: { lat: 50.83, lon: -1.301167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-74-william",
    name: "74 William",
    position: { lat: 50.827667, lon: -1.293167 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-76-test",
    name: "76 Test",
    position: { lat: 50.8765, lon: -1.390833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-77-fawley-deep",
    name: "77 Fawley Deep",
    position: { lat: 50.840333, lon: -1.319833 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
  {
    id: "rm-78-hook",
    name: "78 Hook #",
    position: { lat: 50.825333, lon: -1.305 },
    type: "buoy",
    rcs: 0.05,
    category: "special",
    light: {
      character: "Fl.Y.4s",
      pattern: { kind: "flash", periodSec: 4 },
      color: "Y",
      rangeNm: 3,
    },
  },
];
